import axios from "axios";
import profile from "./profile";
import { iviewMsgForJs,$t } from "../main";
import jwt_decode from "jwt-decode";
import main from "./main";


let refreshing = false
// 不需要存儲 serverLocation變數，直接在需要時調用 main.getServerLocation()

// http request 拦截器
axios.interceptors.request.use(
  async (config) => {
    
    if(config.url.indexOf('api2-alpha')!=-1){
      return config
    }
    if (config.url.indexOf("api2") != -1 && config.url.indexOf("oauth2/login") != -1) {
      let flag = checkTokenExpired();
      if (flag) {
        if (!refreshing) {
          if (localStorage.getItem("access_token")&& !sessionStorage.getItem("jumpFrom")) {
            await refreshToken();
          }
          else if (localStorage.getItem("access_token")&&sessionStorage.getItem("jumpFrom")=="HT") {
            iviewMsgForJs.info($t("refreshToken"));

            // 如果在 game-act-manager 頁面，導航回 HTwbActKitHome
            if (window.location.pathname === '/game-act-manager') {
              localStorage.removeItem("access_token")
              localStorage.removeItem("expires_in")
              localStorage.removeItem("id_token")
              localStorage.removeItem("profile")
              window.location.href = '/htwb-actkit-home';
            } else {
              // 其他頁面保持原本邏輯
              const url = new URL(window.location.href);
              url.searchParams.delete('userInfo');
              window.location.href = url.toString();
            }
          }
        }
      }
      return config;
    } else {
      return handleHeader(config);
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 全局變量記錄是否正在刷新 Token
let isRefreshingAuthToken = false;

/**
 * 檢查並刷新 Auth Token
 * 使用鎖定機制避免並發請求同時刷新
 */
async function refreshTokenIfExpired() {
  // 如果已經在刷新中，則等待完成
  if (isRefreshingAuthToken) {
    // 等待直到刷新完成
    let retryCount = 0;
    while (isRefreshingAuthToken && retryCount < 10) {
      await new Promise(resolve => setTimeout(resolve, 100));
      retryCount++;
    }
    return;
  }
  
  //檢查auth_token是否即將過期
  const authExpiry = localStorage.getItem("auth_token_expiry");
  const now = Date.now();
  const refreshThreshold = 120 * 1000; // 提前 120 秒刷新

  if (!authExpiry || !localStorage.getItem("auth_token")) {
    // Token 不存在，需要獲取
    try {
      isRefreshingAuthToken = true;
      await initializeAuth();
      isRefreshingAuthToken = false;
      return true;
    } catch (error) {
      isRefreshingAuthToken = false;
      console.error("Error initializing auth token", error);
      return false;
    }
  } else if (authExpiry) {
    const exp = parseInt(authExpiry) * 1000; // 将 exp 转换为毫秒
    // console.log('auth_token 剩餘時間:' + ((exp - now) / 1000 / 60).toFixed(2), "分鐘");
    
    if (exp - now < refreshThreshold) {
      try {
        isRefreshingAuthToken = true;
        await initializeAuth();
        isRefreshingAuthToken = false;
        return true;
      } catch (error) {
        isRefreshingAuthToken = false;
        console.error("Error refreshing auth token", error);
        return false;
      }
    }
  }
  return false;
}

/**
 * 初始化 Auth Token
 */
async function initializeAuth() {
  try {
    const res = await post("/Auth/get-authtoken");
    if (res.data && res.data.auth_token) {
      const exp = jwt_decode(res.data.auth_token).exp;
      localStorage.setItem("auth_token", res.data.auth_token);
      localStorage.setItem("auth_token_expiry", exp);
      return res.data.auth_token;
    }
    return null;
  } catch (error) {
    console.error("Error fetching auth token", error);
    return null;
  }
}

/**
 * 處理請求頭
 */
async function handleHeader(config) {
  // 確保 Token 有效
  await refreshTokenIfExpired()
  
  let flag = checkTokenExpired();
  if (flag) {
    if (!refreshing) {
      if (localStorage.getItem("access_token")&& !sessionStorage.getItem("jumpFrom")) {
        await refreshToken();
      }
      else if (localStorage.getItem("access_token")&&sessionStorage.getItem("jumpFrom")=="HT") {
        iviewMsgForJs.info($t("refreshToken"));

        // 如果在 game-act-manager 頁面，導航回 HTwbActKitHome
        if (window.location.pathname === '/game-act-manager') {
          localStorage.removeItem("access_token")
          localStorage.removeItem("expires_in")
          localStorage.removeItem("id_token")
          localStorage.removeItem("profile")
          window.location.href = '/htwb-actkit-home';
        } else {
          // 其他頁面保持原本邏輯
          const url = new URL(window.location.href);
          url.searchParams.delete('userInfo');
          window.location.href = url.toString();
          localStorage.removeItem("access_token")
          localStorage.removeItem("expires_in")
        }
      }
    }
  }
  if (localStorage.getItem("access_token")) {
    config.headers["Authorization"] = "Bearer " + localStorage.getItem("access_token");
  }
  config.headers["Content-Type"] = "application/json";
  config.headers["lang"] = localStorage.getItem("local") || navigator.language.toLowerCase();

  //检查auth_token是否存在
  let auth_token = localStorage.getItem("auth_token");
  //以下為驗證auth_token，無者Logout  先封印
  //if (!auth_token) {
  //    console.log('auth_token失败', config)
  //    loginOut()
  //    sessionStorage.setItem('loginOut', 'localStorage没有auth_token：auth_token失败，重新登录')
  //    return
  //}
  //通过验证设置对应参数
  if (auth_token) {
    config.headers["X-Auth-AuthToken"] = auth_token;
  }
  else{
    initializeAuth()
    config.headers["X-Auth-AuthToken"] = localStorage.getItem("auth_token");
  }
  return config;
}

/** 檢查Token是否快過期 */
function checkTokenExpired() {
  // 如果 expires_in 為空或未定義，我們需要檢查 access_token 是否存在
  if (!localStorage.getItem("expires_in") || localStorage.getItem("expires_in") === undefined) {
    // 如果有 access_token 但沒有 expires_in，為安全起見，應該刷新 token
    if (localStorage.getItem("access_token")) {
      console.warn("expires_in 為空但 access_token 存在，建議刷新 token");
      return true;
    }
    return false; // 如果沒有 token，則不需要刷新
  }
  
  var nowTime = new Date();
  let cT = Date.parse(nowTime);

  let formattedExpiresIn = localStorage.getItem("expires_in");
  
  // 檢查 formattedExpiresIn 是否為空字符串
  if (!formattedExpiresIn || formattedExpiresIn.trim() === "") {
    console.warn("expires_in 存在但為空字符串");
    return true;
  }

  // 處理不同格式的日期字符串
  try {
    if (!formattedExpiresIn.includes("T")) {
      formattedExpiresIn = formattedExpiresIn.replace(" ", "T");
      formattedExpiresIn = formattedExpiresIn + "+00:00";
    }

    let eT = Date.parse(formattedExpiresIn);
    
    // 檢查日期解析是否成功
    if (isNaN(eT)) {
      console.error("無法解析 expires_in 日期格式:", localStorage.getItem("expires_in"));
      return true; // 如果無法解析，為安全起見，視為需要刷新
    }
    
    let btw = eT - cT;
    // console.log('access_token 剩餘時間:'+(btw/1000/60).toFixed(2), "分鐘");
    if (btw < 120 * 1000) { //120秒前請求過期
      return true;
    } else {
      return false;
    }
  } catch (error) {
    console.error("檢查 token 過期時發生錯誤:", error);
    return true; // 發生錯誤時，為安全起見，視為需要刷新
  }
}

/** 刷新token */
async function refreshToken() {
  try {
    refreshing = true;
    console.log("開始刷新 access_token...");
    
    // 確保使用正確的 serverLocation
    const currentServerLocation = main.getServerLocation();
    
    const response = await axios.post(profile.apiUrl[currentServerLocation] + "/oauth2/token", {
      grant_type: "refresh_token",
      client_id: profile.clientID[currentServerLocation],
      access_token: localStorage.getItem("access_token"),
    });
    
    if (response && response.data && response.data.access_token) {
      // 保存新的 token
      localStorage.setItem("access_token", response.data.access_token);
      localStorage.setItem("expires_in", response.data.expires_in);
      console.log("access_token 刷新成功");
    } else {
      console.error("刷新 token 時返回的數據格式不正確", response);
    }
  } catch (error) {
    console.error("刷新 token 失敗:", error);
  } finally {
    refreshing = false;
  }
}

// 退出登錄
//function loginOut() {
//    localStorage.clear()
//    window.location.href = window.location.origin + '/login'
//}

//轉換URL
//本機測試環境對策：1.SSL對策 2.前後端port不一致對策
//內容：
function transferUrlIfTest(url) {
  var domain = "";
  var protocol = window.location.protocol;
  var hostname = protocol + "//" + window.location.hostname + (window.location.port ? ":" + window.location.port : "");
  domain = hostname.includes("localhost:5005") 
    ? hostname.replace("localhost:5005", "localhost:5004") 
    : hostname.includes("192.168.0.214:5005") 
    ? hostname.replace("192.168.0.214:5005", "192.168.0.214:5004") 
    : "";
  return `${domain}${url}`;
}

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function get(url, params) {
  url = transferUrlIfTest(url);
  let data = {};
  data.method = url;
  data.params = params;
  data.lang = localStorage.getItem("local");
  return new Promise((resolve, reject) => {
    axios
      .get(url, data)
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function post(url, params) {
  if (
    url.indexOf("api2") == -1 &&
    url.indexOf("https://bb-rc") == -1 &&
    url.indexOf("https://www.teammodel.net") == -1 && // ies5正式站
    url.indexOf("https://ies5-rc.teammodel.net") == -1 && // ies5 RC站
    url.indexOf("https://test.teammodel.net") == -1 // ies5 test站
  ) {
    url = transferUrlIfTest(url);
  }
  // console.log(url)
  let data = { url };
  data.method = url;
  data.params = params;
  data.lang = localStorage.getItem("local");
  return new Promise((resolve, reject) => {
    axios.post(url, params).then(
      (response) => {
        if (response) {
          resolve(response.data);
        }
      },
      (err) => {
        reject(err);
      }
    );
  });
}
